if (window.innerWidth >= 1024) {
    const shareContainer = document.querySelector('.share-container');
    const shareBtns = document.querySelector('.addtoany_share_save_container');

    if (shareContainer && shareBtns) {
        shareContainer.appendChild(shareBtns);
    }
}
